export const adminRoutes = [
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    meta: {
      title: 'Admin',
      authRequired: true,
      adminRequired: true,
    },
  },
  {
    path: '/admin/dashboard',
    component: () => import('../views/admin/DashboardView.vue'),
    name: 'Admin Dashboard',
    meta: {
      title: 'Admin Dashboard',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/moderation',
    component: () => import('../views/admin/ModerationView.vue'),
    name: 'Slot Type Moderation',
    meta: {
      title: 'Moderation',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/types',
    component: () => import('../views/admin/TypesView.vue'),
    name: 'Slot Types',
    meta: {
      title: 'Slot Types',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/users',
    component: () => import('../views/admin/UsersView.vue'),
    name: 'Users',
    meta: {
      title: 'Users',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/teams',
    component: () => import('../views/admin/TeamsView.vue'),
    name: 'Teams',
    meta: {
      title: 'Teams',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/users/:id',
    name: 'Manage User',
    component: () => import('../views/admin/UserView.vue'),
    meta: {
      title: 'Manage User',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
  {
    path: '/admin/teams/:id',
    name: 'Manage Team',
    component: () => import('../views/admin/TeamView.vue'),
    meta: {
      title: 'Manage Team',
      authRequired: true,
      adminRequired: true,
      layout: 'AdminLayout',
    },
  },
];
